import {
  EditContextProvider,
  Form,
  useEditController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import {
  Button as MUIButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Resources } from '../../resource';
import DesignatedRedPacketForm from './DesignatedRedPacketForm';
import { updateDesignatedRedPacket, DesignatedRedPacket } from '../../../services/redpacketService';
import { useFormContext } from 'react-hook-form';
import { PermissionButton } from '../../../../../routes/components/permission-button';

const EditDesignatedRedPacket = ({
  id,
  record,
  onClose,
}: {
  id: string | number;
  record: DesignatedRedPacket;
  onClose: () => void;
}) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useEditController({
    id,
    resource: Resources.redpacket,
    mutationMode: 'pessimistic',
    mutationOptions: {
      onSuccess: () => {
        notify('Update successful', { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        notify(error.message || 'Update failed', { type: 'error' });
      },
    },
  });

  const CustomSaveButton = () => {
    const { handleSubmit } = useFormContext();
    const onSubmit = async (data: any) => {
      try {
        await updateDesignatedRedPacket({
          id: String(id),
          designatedAmount: data.designatedAmount ? String(data.designatedAmount) : undefined,
          status: data.status,
          expiresAt: data.expiresAt,
        });
        notify('Update successful', { type: 'success' });
        refresh();
        onClose();
      } catch (error: any) {
        notify(error.message || 'Update failed', { type: 'error' });
      }
    };
    return <MUIButton onClick={handleSubmit(onSubmit)}>Save</MUIButton>;
  };

  if (controller.isLoading || (!controller.record && !record)) return null;

  const currentRecord = record || controller.record;

  return (
    <EditContextProvider value={controller}>
      <Form disableInvalidFormNotification defaultValues={currentRecord}>
        <DialogTitle>Edit Designated Red Packet</DialogTitle>
        <DialogContent>
          <DesignatedRedPacketForm isCreate={false} record={currentRecord} />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="redpacket" action="update">
            <CustomSaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </EditContextProvider>
  );
};

export default EditDesignatedRedPacket;
